// Slides host object
async function vsto_insertImageInCurSlideFromUrl(imageUrl, options) {
  let hostObject = window.chrome.webview.hostObjects.shapesHostObject;
  let index = await hostObject.addPictureInCurrentSlideFromUrl(
    imageUrl,
    options
  );
  return index;
}

async function vsto_getSlideImageOptionsThenDel() {
  let hostObject = window.chrome.webview.hostObjects.shapesHostObject;
  return await hostObject.getSlideImageOptionsThenDel();
}

async function vsto_insertImageInCurSlideFromData(data, options) {
  let hostObject = window.chrome.webview.hostObjects.shapesHostObject;
  let index = await hostObject.addPictureInCurrentSlideFromData(data, options);
  return index;
}

async function vsto_getSlideAllText(includeContent = false) {
  let hostObject = window.chrome.webview.hostObjects.shapesHostObject;
  return await hostObject.getSlideAllText(includeContent);
}

async function vsto_getSlideTextWithName(shapeName) {
  let hostObject = window.chrome.webview.hostObjects.shapesHostObject;
  return await hostObject.getSlideTextWithName(shapeName);
}

async function vsto_updateSlideTextWithName(shapeName, text) {
    let hostObject = window.chrome.webview.hostObjects.shapesHostObject;
    return await hostObject.updateSlideTextWithName(shapeName, text);
}

async function vsto_updateSlideContent_ClassicCanvans(generateContent)
{
    let hostObject = window.chrome.webview.hostObjects.shapesHostObject;
    return await hostObject.updateSlideContent_ClassicCanvans(generateContent);
}

async function vsto_updateSlideContent_MarketAdoption(generateContent) {
    let hostObject = window.chrome.webview.hostObjects.shapesHostObject;
    return await hostObject.updateSlideContent_MarketAdoption(generateContent);
}

async function vsto_updateSlideContent_MarketSize(generateContent) {
    let hostObject = window.chrome.webview.hostObjects.shapesHostObject;
    return await hostObject.updateSlideContent_MarketSize(generateContent);
}

export default {
  vsto_insertImageInCurSlideFromUrl,
  vsto_getSlideImageOptionsThenDel,
  vsto_insertImageInCurSlideFromData,
  vsto_getSlideAllText,
  vsto_getSlideTextWithName,
  vsto_updateSlideTextWithName,
  vsto_updateSlideContent_ClassicCanvans,
  vsto_updateSlideContent_MarketAdoption,
  vsto_updateSlideContent_MarketSize,
};
